<template>
    <transition name="fade">
        <div class="modal-mask video-modal">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-body">
                        <button class="btn-close" @click="videoModelAction">X</button>
                        <iframe width="100%" height="100%" :src="videoUrl" title="THRIVE | Initiative" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen>
                        </iframe>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Button from "../UI/Button";
import mixins from "../../config/mixins";

export default {
    name: "VideoModel",
    components: {
        Button
    },
    mixins: [mixins.npos, mixins.plaid],
    props: ["url", "title", "id", "postVideoUrl"],
    data: function () {
        return {
            isActive: false,
            videoUrl: "https://www.youtube.com/embed/ZQItY298VxU",
        }
    },
    mounted() {
        if ((this.$getState('corporation')['is'] && this.postVideoUrl) || (!this.$getState('corporation')['is'] && this.postVideoUrl)) {
            this.videoUrl = this.postVideoUrl;
        }
        if (this.$getState('corporation')['is'] && !this.postVideoUrl) {
            this.videoUrl = this.$getState('corporation')['youtube_video_link'];
        }
    },
    methods: {
        clickHandler: function () {
            this.recreate = 0;
            this.plaidLoad();
        },
        videoModelAction: function () {
            if (this.isActive) {
                this.$emit('showModel', false)
            } else {
                this.$emit('showModel', true)
            }
        }

    },
};
</script>

<style lang="scss">
@import '../../../sass/_variables.scss' ;
.video-modal {
    .btn-close {
        color: #ffffff;
        background: $color__bg;
        padding: 2px 8px;
        font-weight: 700;
        z-index: 10000;
        border-radius: 50%;
        position: absolute;
        transform: translate(-50%, -50%);
        right: -2%;
        top: 37%;
    }

    .modal-container {
        width: 100%;
        padding: 0px 11px;
        max-width: 100%;
        box-shadow: none !important;
        background-color: transparent !important;
        margin: 0 auto !important;

        .modal-body {
            width: 100%;
            height: 209px;
        }
    }
}
</style>